/* Game page when it is loading, it has an error, or unable to obtain currentRound*/

import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import FixedPageWrapper from '../components/wrapper/FixedPageWrapper';
import GhostWrapper from '../components/wrapper/GhostWrapper';
import GameGhosts from './../components/ghosts/GameGhosts';
import Header from './../components/general/Header';
import Title from './../components/text/Title';
import Subtitle from './../components/text/Subtitle';
import Button from './../components/general/Button';
import Footer from './../components/general/Footer';

function GamePlaceholder({ status, errorName = '' }) {
  const { t } = useLanguage();

  return (
    <FixedPageWrapper>
      <GhostWrapper>
        <Header text="Why is autocomplete so biased" />
        <Title size="small" text={t('title')} />
        <br />
        {status === 'loading' && <Subtitle text={t('loading')} />}

        {status === 'error' && (
          <>
            <Subtitle text={`${t('error')} ${errorName}`} />
            <br />
            <Link to="/">
              <Button text={t('goHome')} />
            </Link>
          </>
        )}

        {status === 'noCurrentRound' && (
          <>
            <Subtitle text={`${t('error')}${t('noCurrentRoundAvailable')}`} />
            <br />
            <Link to="/">
              <Button text={t('goHome')} />
            </Link>
          </>
        )}
      </GhostWrapper>
      <GameGhosts />
      <Footer />
    </FixedPageWrapper>
  );
}

export default GamePlaceholder;
